import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import React, {useMemo} from "react";
import runeShards from "../../../../store/static_json/runeShards";
import runeShards_en from "../../../../store/static_json/runeShards_en";
import JustRuneImage from "../ChampionsDetailRunes/JustRuneImage";
import DetailMapRune from "../ChampionsDetailRunes/DetailPrimaryRunes";
import useRuneFunc from "../../../../common/hooks/useRuneFunc";

const HeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: ${props => props.theme.color.dark_100};
  padding-left: 12px;
  border-bottom: 1px solid ${props => props.theme.color.default_border_color};
  position: relative;
  height: 26px;
`;


const RuneContent = styled.div`
  width: 100%;
  height: 100%;
  min-height: 285px;
  background-color: ${props => props.theme.color.site_main_color};
`;
const RuneBox = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  border-radius: 6px;
`;
const MainRuneWrapper = styled.div`
  width: 166px;
  display: flex;
  flex-direction: column;
`;

const SubRuneWrapper = styled.div`
  width: 148px;
  display: flex;
  flex-direction: column;
  margin-left: 30px;
`;

const SubRune = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: ${props => props.marginTop || 15}px;
  padding: ${props => props.padding || 0};
`;


const MainRuneInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: ${props => props.marginBottom || 0}px;
`;

const MainRuneText = styled.span`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 10px;
`;

const MainRuneInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
`;
const DiamondWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  opacity: 0.5;
  margin-top: 14px;
`;

const DiamondBar = styled.div`
  width: 95%;
  height: 1px;
  background-color: #CAD7E2;
`;
const AbsoluteDiamon = styled.div`
  position: absolute;
  left: ${props => props.left}px;
  right: ${props => props.right}px;
`;

const Diamond = styled.div`
  width: 0;
  height: 0;
  border: 4px solid transparent;
  border-bottom-color: #CAD7E2;
  position: relative;
  top: -4px;

  &:after {
    content: '';
    position: absolute;
    left: -4px;
    top: 4px;
    width: 0;
    height: 0;
    border: 4px solid transparent;
    border-top-color: #CAD7E2;
  }
`;

const Wrapper = styled.div`
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.color.site_main_color};
`;

const JustRuneImageBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #000;
  width: 24px;
  height: 24px;

  opacity: ${props => {
    let opacity = '1';
    if (props.disalbed) opacity = '0.3';
    return opacity;
  }};

  & + & {
    margin-left: 5px;
  }
`;
const JustRuneImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const ShardWrapper = styled.div`
  margin-top: 5px;
`;

const ChampionDetailBuildRuneBuild = ({runeList}) => {
    const {i18n, t} = useTranslation();
    const runes = useSelector((state) => state.champions.buildRune);
    const {getRuneBorderColor, findParentRune, findChildRune, findCategoryRune} = useRuneFunc();
    const currentRuneShards = useMemo(() => ['ko', 'ko-KR'].includes(i18n.language) ? runeShards : runeShards_en, [i18n.language]);


    const selectedRune = useMemo(() => findParentRune(runes, runeList?.main_build?.[0]), [runes, runeList])
    const subSelectedRune = useMemo(() => findParentRune(runes, runeList?.sub_build?.[0]), [runes, runeList])

    if (!Array.isArray(runeList?.main_build)) return null
    if (runeList?.main_build?.length < 1) return null
    return (
        <Wrapper className={'summoner_mastery_wrapper'}>
            <RuneContent>
                <RuneBox>
                    <MainRuneWrapper>
                        <MainRuneInfo>
                            <MainRuneInfoBox marginBottom={0}>
                                {/*<JustRuneImage*/}
                                {/*    width={24}*/}
                                {/*    height={24}*/}
                                {/*    image={findParentRune(runes, runeList?.rune_main?.[0])?.icon}*/}
                                {/*/>*/}
                                <JustRuneImageWrapper>
                                    {runes.map((data) => {
                                        return (
                                            <JustRuneImageBox disalbed={selectedRune?.id !== data?.id} key={data?.id}>
                                                <JustRuneImage image={data.icon} height={18} width={18}/>
                                            </JustRuneImageBox>)
                                    })}
                                </JustRuneImageWrapper>
                            </MainRuneInfoBox>
                        </MainRuneInfo>
                        {findParentRune(runes, runeList?.main_build?.[0])?.slots?.map((data, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <SubRune marginTop={15} padding={index !== 0 ? '0 9px' : 0}>
                                        <DetailMapRune
                                            width={index === 0 ? 42 : 36}
                                            height={index === 0 ? 42 : 36}
                                            selectedRune={[...runeList.main_build]}
                                            imageBorder={2}
                                            borderColor={getRuneBorderColor(selectedRune.id)}
                                            runes={data.runes}
                                        />
                                    </SubRune>
                                </React.Fragment>
                            )
                        })}
                    </MainRuneWrapper>
                    <SubRuneWrapper>
                        <MainRuneInfo>
                            <MainRuneInfoBox marginBottom={0}>
                                {/*<JustRuneImage*/}
                                {/*    width={24}*/}
                                {/*    height={24}*/}
                                {/*    image={findParentRune(runes, runeList?.rune_sub?.[0])?.icon}*/}
                                {/*/>*/}
                                <JustRuneImageWrapper>
                                    {runes.map((data) => {
                                        if (selectedRune.id === data.id) return null;
                                        return (
                                            <JustRuneImageBox disalbed={subSelectedRune?.id !== data?.id}
                                                              key={data?.id}>
                                                <JustRuneImage image={data.icon} height={18} width={18}/>
                                            </JustRuneImageBox>)
                                    })}
                                </JustRuneImageWrapper>
                            </MainRuneInfoBox>
                        </MainRuneInfo>
                        {findParentRune(runes, runeList?.sub_build?.[0])?.slots?.map((data, index) => {
                            if (index === 0) return null
                            return (
                                <SubRune key={index}>
                                    <DetailMapRune
                                        width={36}
                                        height={36}
                                        selectedRune={[...runeList.sub_build]}
                                        imageBorder={2}
                                        borderColor={getRuneBorderColor(subSelectedRune.id)}
                                        runes={data.runes}
                                    />
                                </SubRune>
                            )
                        })}
                        <ShardWrapper>

                            {currentRuneShards?.slots?.map((data, index) => {
                                const selectedRuneData = () => {
                                    if (index === 0) {
                                        return [runeList.stat_build?.[2]];
                                    } else if (index === 1) {
                                        return [runeList.stat_build?.[1]]
                                    } else if (index === 2) {
                                        return [runeList.stat_build?.[0]]
                                    }
                                }
                                return (
                                    <SubRune key={index} padding={'0 8px'} marginTop={10}>
                                        <DetailMapRune
                                            width={24}
                                            height={24}
                                            selectedRune={selectedRuneData()}
                                            imageBorder={2}
                                            borderColor={"#46B9AA"}
                                            runes={data.runes}
                                        />
                                    </SubRune>
                                )
                            })}

                        </ShardWrapper>
                    </SubRuneWrapper>
                </RuneBox>
            </RuneContent>
        </Wrapper>
    );
};

export default ChampionDetailBuildRuneBuild;
